import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { API_URL_All } from '../api';
import axiosInstance from '../axiosInstance';
import AdminLayout from '../components/AdminLayout';
import * as general from '../libs/general';
import { toast } from "react-toastify";
import { MedalGold, MedalSilver, MedalBronze } from '../components/tickets/Tickets';
import { fetchSettingsPermissions } from "../libs/customerCreatePermission";


const roundPercent = (value) => Math.min(100, Math.max(0, Math.round(value * 100) / 100));

const ParameterUser = () => {

  const [model, setModel] = useState({});
  const [title, setTitle] = useState('');
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [key, setKey] = useState(0);
  const [settingsPerm, setSettingsPerm] = useState({
    loaded: false,
    canView: false,
    canEdit: false,
  });

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const p = await fetchSettingsPermissions(axiosInstance);
      if (cancelled) return;
      setSettingsPerm({
        loaded: true,
        canView: Boolean(p?.canView),
        canEdit: Boolean(p?.canEdit),
      });
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!settingsPerm.loaded || !settingsPerm.canView) return;
    const fetchPageContents = async () => {
      try {
        var requestApi = `/api/import-orders/getSetting`;
        const response = await axiosInstance.get(requestApi);
        console.log(response.data.data);

        setModel(response.data.data);

        setTitle('Cài đặt xếp hạng');

      } catch (error) {
        toast.error(error.message);
        console.error("Error fetching :", error);
      }
    };

    fetchPageContents();
  }, [key, settingsPerm.loaded, settingsPerm.canView]);

  const setDataModel = (name, e) => {
    if (!settingsPerm.canEdit) return;
    var value = e.target.value;
    var newModel = { ...model };

    if (name === 'bronze') {
      // Ô hiển thị dạng 5.000.000: bỏ dấu phân cách, chỉ giữ chữ số.
      value = value.replace(/\D/g, '');
      let valueInt = parseInt(value);
      newModel.silver = valueInt * 5;
      newModel.gold = valueInt * 25;
    }

    if (name === 'bronzeDiscount') {
      // Gợi ý theo hệ số giống số tiền; từng bậc vẫn sửa riêng được.
      const percent = parseFloat(value);
      if (!isNaN(percent)) {
        newModel.silverDiscount = roundPercent(percent * 5);
        newModel.goldDiscount = roundPercent(percent * 25);
        newModel.diamondDiscount = roundPercent(percent * 125);
      }
    }

    newModel[name] = value;
    setModel(newModel);

  };

  const discountInput = (name) => (
    <input
      type="number"
      className="form-control"
      min="0"
      max="100"
      step="0.01"
      readOnly={!settingsPerm.canEdit}
      value={model[name] ?? ''}
      onChange={(e) => setDataModel(name, e)}
    />
  );

  const saveSetting = async () => {
    if (!settingsPerm.canEdit) {
      toast.warning("Bạn không có quyền cập nhật.");
      return;
    }
    try {
      var requestApi = `/api/import-orders/saveSetting`;
      const response = await axiosInstance.post(requestApi, model);
      if (!response.data.success) {
        toast.error(response.data.message);
        return;
      }

      toast.success(response.data.message);
    } catch (error) {
      toast.error(error.message);
      console.error("Error fetching :", error);
    }
  };

  return (
    <div>
      <AdminLayout>
        {settingsPerm.loaded && !settingsPerm.canView ? (
          <div className="container-fluid p-3 p-md-4">
            <div className="alert alert-warning mb-0">Bạn không có quyền truy cập màn hình này.</div>
          </div>
        ) : (
        <>
        <div className="right_col" role="main">
          <div className="row">
            <div className="col-md-12 col-sm-12 ">
              <div className="x_panel">
                <div className="x_title">
                  <h2 className="fw-bold">Cài đặt xếp hạng</h2>
                  <ul className="nav navbar-right panel_toolbox">
                  </ul>
                  <div className="clearfix"></div>
                </div>
                <div className="x_content calc-200">
                  <form id="form_colors" className="" action="" method="post" noValidate>
                    <div className="table-s table-normal">
                      <table>
                        <tbody>
                          <tr>
                            <th width="50px">STT</th>
                            <th>Huy chương</th>
                            <th><span data-note="kg">Giá trị</span></th>
                            <th><span data-note="%">Chiết khấu</span></th>
                            <th>Mô tả</th>
                          </tr>
                          <tr>
                            <td>1</td>
                            <td className="cell-normal text-center">
                              <div className="medal-line justify-content-center medal-x">
                                <span className="medal medal-bronze"></span>
                              </div>
                            </td>
                            <td>
                              <input type="text" inputMode="numeric" className="form-control" readOnly={!settingsPerm.canEdit} value={general.formatNumber(model.bronze)} onChange={(e) => setDataModel('bronze', e)} />
                            </td>
                            <td>{discountInput('bronzeDiscount')}</td>
                            <td className="cell-normal">Ngưỡng đạt huy chương Đồng</td>
                          </tr>
                          <tr>
                            <td>2</td>
                            <td className="cell-normal text-center">
                              <div className="medal-line justify-content-center medal-x">
                                <span className="medal medal-silver"></span>
                              </div>
                            </td>
                            <td>
                              <input type="text" className="form-control" value={general.formatNumber(model.silver)} disabled={true} onChange={(e) => setModel({ ...model, silver: e.target.value })} />
                            </td>
                            <td>{discountInput('silverDiscount')}</td>
                            <td className="cell-normal">Ngưỡng đạt huy chương Bạc</td>
                          </tr>
                          <tr>
                            <td>3</td>
                            <td className="cell-normal text-center">
                              <div className="medal-line justify-content-center medal-x">
                                <span className="medal medal-gold"></span>
                              </div>
                            </td>
                            <td>
                              <input type="text" className="form-control" value={general.formatNumber(model.gold)} disabled={true} onChange={(e) => setModel({ ...model, gold: e.target.value })} />
                            </td>
                            <td>{discountInput('goldDiscount')}</td>
                            <td className="cell-normal">Ngưỡng đạt huy chương Vàng</td>
                          </tr>
                          <tr>
                            <td>4</td>
                            <td className="cell-normal text-center">

                              <div className="medal-line justify-content-center medal-x">
                                <span className="medal medal-dimond"></span>
                              </div>

                            </td>
                            <td>
                              <input type="text" className="form-control" value={general.formatNumber(model.bronze * 125)} disabled={true} onChange={(e) => setModel({ ...model, gold: e.target.value })} />
                            </td>
                            <td>{discountInput('diamondDiscount')}</td>
                            <td className="cell-normal">Ngưỡng đạt kim cương</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div className="row g-2 align-items-center mt-3">
                      <label className="col-auto form-label mb-0 fw-semibold">
                        <span data-note="%">Chiết khấu tối đa</span>
                      </label>
                      <div className="col-auto px-3" style={{ width: 160 }}>
                        {discountInput('maxRankDiscount')}
                      </div>
                      <div className="col small text-muted">
                        Tổng chiết khấu theo huy chương của một khách không vượt quá mức này.
                      </div>
                    </div>

                    <div className="ln_solid1">
                      <div className="form-group">
                        <div className="col-12 text-center">
                          <button type='reset' className="btn-s btn btn-success" disabled={!settingsPerm.canEdit} onClick={(event) => setKey(prev => prev + 1)}>Hủy</button>
                          <button type='button' className="btn-s btn btn-primary" disabled={!settingsPerm.canEdit} onClick={saveSetting}>Lưu</button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>


          </div>
        </div>
        <footer className="d-none"> </footer>
        </>
        )}
      </AdminLayout>
    </div>
  );
};

export default ParameterUser;